import Typography from "@mui/joy/Typography";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";

const EditClientModal = ({ open, onClose, lead, agentlist = [] }) => {
  return (
    <>
      <Modal open={open} onClose={onClose}>
        <ModalDialog
          variant="outlined"
          role="alertdialog"
          className="max-w-2xl"
        >
          <ModalClose />
          <Typography level="h4" className="mb-6">
            Edit Client Information
          </Typography>
          <div className="grid grid-cols-2 gap-4 mb-6">
            <FormControl>
              <FormLabel>Company Name</FormLabel>
              <Input defaultValue={lead?.full_name} disabled />
            </FormControl>
            <FormControl>
              <FormLabel>Contact Name</FormLabel>
              <Input defaultValue={lead?.full_name} disabled />
            </FormControl>
            <FormControl>
              <FormLabel>Phone</FormLabel>
              <Input defaultValue={lead?.phone} disabled />
            </FormControl>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input defaultValue={lead?.email} disabled />
            </FormControl>
            <FormControl>
              <FormLabel>Source</FormLabel>
              <Input defaultValue={lead?.source} disabled />
            </FormControl>
            <FormControl>
              <FormLabel>Site Visit Intent</FormLabel>
              <Input defaultValue={lead?.lead_type} disabled />
            </FormControl>
          </div>
          <Button disabled color="primary" fullWidth sx={{ mt: 2 }}>
            Update Information
          </Button>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default EditClientModal;
